import './index.css'

import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'

// Получаем данные из window.__MODX_DATA__
const data = window?.__MODX_DATA__ || {
  helmet: {
    title: `Заголовок`,
    host: `localhost:3001`
  },
  pagetitle: `Тест`,
  content: ``,
  slogan: ``,
  template: 1
}

console.log('Client hydration:', data)

let root = createRoot( document.getElementById('prompek') );
root.render(
  <App
    data={data}
  />
)